import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SgObjectViewComponent } from './object-view.component';
import { SgObjectViewCellDefDirective, SgObjectViewHeaderCellDefDirective } from './directives';

@NgModule({
  imports: [CommonModule],
  declarations: [SgObjectViewComponent, SgObjectViewCellDefDirective, SgObjectViewHeaderCellDefDirective],
  exports: [SgObjectViewComponent, SgObjectViewCellDefDirective, SgObjectViewHeaderCellDefDirective],
})
export class SgObjectViewModule {}
